import { call, all, put, takeLatest } from "redux-saga/effects";
import { doGet, doPut, doPost } from "../utils/request";
import {
  getEtoZonesSuccess,
  getEtoZonesFail,
  getZonesOfDistrictSuccess,
  getZonesOfDistrictFail,
  assignZonesToETOSuccess,
  assignZonesToETOFail,
  getZonesbyDistrictSuccess,
  getZonesbyDistrictFail,
  getDistrictCirclesSuccess,
  getHighwaysOfDistrictSuccess,
  getHighwaysOfDistrictFail,
  editTableValuesSuccess,
  editTableValuesFail,
  editHighwayValueSuccess,
  editHighwayValueFail,
  editZoneValueSuccess,
  editZoneValueFail,
  addDistrictSuccess,
  addDistrictFail,
  getDistrictCirclesFail,
} from "../actionCreators/Zones";

function* getEtoZones({ obj }) {
  try {
    const response = yield doGet(
      obj?.districtId
        ? `/zones/all?districtId=${obj?.districtId}`
        : `/zones/all`
    );
    yield put(getEtoZonesSuccess(response.data));
  } catch (err) {
    yield put(getEtoZonesFail(err.response.data.message || err.message));
    yield put(getEtoZonesFail());
  }
}

function* getZonesOfDistrict({ obj }) {
  try {
    const response = yield doGet(
      `/dropdowns/getZonesOfDistrict?districtId=${obj?.districtId}`
    );
    yield put(getZonesOfDistrictSuccess(response.data));
  } catch (err) {
    yield put(getZonesOfDistrictFail(err.response.data.message || err.message));
    yield put(getZonesOfDistrictFail());
  }
}
function* getZonesbyDistrict({ obj }) {
  try {
    const response = yield doGet(
      `zones?limit=${obj.limit}&page=${obj.page}&districtId=${obj.district_id}`
    );
    yield put(getZonesbyDistrictSuccess(response.data));
  } catch (err) {
    yield put(getZonesbyDistrictFail(err.response.data.message || err.message));
    yield put(getZonesbyDistrictFail());
  }
}
function* getCirclesByDistrict({ obj }) {
  try {
    const response = yield doGet(
      `circles?limit=${obj.limit}&page=${obj.page}&districtId=${obj.district_id}`
    );
    yield put(getDistrictCirclesSuccess(response.data));
  } catch (err) {
    yield put(getDistrictCirclesFail(err.response.data.message || err.message));
    // yield put(getDistrictCirclesFail());
  }
}
function* getHighwaysOfDistrict({ obj }) {
  try {
    const response = yield doGet(
      `highways?limit=${obj.limit}&page=${obj.page}&districtId=${obj.district_id}`
    );
    yield put(getHighwaysOfDistrictSuccess(response.data));
  } catch (err) {
    yield put(getHighwaysOfDistrictFail(err.response.data.message || err.message));
    yield put(getHighwaysOfDistrictFail());
  }
}
function* assignZonesToETO({ obj }) {
  try {
    const response = yield doPut(`usereto/assignIndividualZoneToEto`, obj);
    yield put(assignZonesToETOSuccess(response.data));
  } catch (err) {
    yield put(assignZonesToETOFail(err.response.data.message || err.message));
    yield put(assignZonesToETOFail());
  }
}
function* updateTableValue({ obj }) {
  try {
    const response = yield doPut(`/circles/${obj?.circle_id}`,obj);
    yield put(editTableValuesSuccess(response.data));
  } catch (err) {
    yield put(editTableValuesFail(err.response.data.message || err.message));
  }
}
function* editHighwayValue({ obj }) {
  try {
    const response = yield doPut(`/highways/${obj?.highway_id}`,obj);
    yield put(editHighwayValueSuccess(response.data));
  } catch (err) {
    yield put(editHighwayValueFail(err.response.data.message || err.message));
  }
}
function* editZoneValue({ obj }) {
  try {
    const response = yield doPut(`/zones/${obj?.zone_id}`,obj);
    yield put(editZoneValueSuccess(response.data));
  } catch (err) {
    yield put(editZoneValueFail(err.response.data.message || err.message));
  }
}
function* addDistrict({ obj }) {
  try {
    const response = yield doPost(`/dataentry/add-districts`,obj);
    yield put(addDistrictSuccess(response.data));
  } catch (err) {
    yield put(addDistrictFail(err.response.data.message || err.message));
  }
}


export default function* watcher() {
  yield all([
    takeLatest("ASSIGN_ZONES_TO_ETO", assignZonesToETO),
    takeLatest("GET_ZONES_OF_DISTRICT", getZonesOfDistrict),
    takeLatest("GET_ALL_ETO_ZONES", getEtoZones),
    takeLatest("ZONES_BY_DISTRICT", getZonesbyDistrict),
    takeLatest("GET_DISTRICT_CIRCLES", getCirclesByDistrict),
    takeLatest("GET_HIGHWAYS_OF_DISTRICT", getHighwaysOfDistrict),
    takeLatest("EDIT_TABLE_VALUES", updateTableValue),
    takeLatest("EDIT_HIGHWAY_VALUE", editHighwayValue),
    takeLatest("EDIT_ZONE_VALUE", editZoneValue),
    takeLatest("ADD_DISTRICT", addDistrict),
  ]);
}
